import { SqsConfigContent } from "./SQSConfig";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";
import { Button } from "semantic-ui-react";
import React from "react";

export function getDecodeOutputSQSValues(sqsValue: string): string[] {
    let input_string = sqsValue;
    let isFifoString = "";
    if (input_string.endsWith(".fifo")) {
        isFifoString = ".fifo";
        input_string = input_string.replace(".fifo", "");
    }
    return ["a", "b"].map((suffix) => `a205419-data-extractor-${input_string}-${suffix}-$ENV${isFifoString}`);
}

export function getEncodeOutputSQSValue(sqsValue: string): string | undefined {
    const match = sqsValue.match(new RegExp(/^(a205419-data-extractor-)(.*)(-[ab]-\$ENV)(\.fifo)?$/));
    if (match) {
        return `${match[2]}${match[4] || ""}`;
    }
}

export function getUniqueSQSValues(sqsConfigContent: { [key: string]: string[] }): string[] {
    const sqsValues = Object.values(sqsConfigContent).flat();
    const encodedSQSValues = Array.from(new Set(sqsValues.map((sqsValue) => getEncodeOutputSQSValue(sqsValue))));
    return encodedSQSValues.filter((value) => value !== undefined) as string[];
}

export function jsonsEqual(obj1: SqsConfigContent, obj2: SqsConfigContent): boolean {
    if (!arraysEqual(Object.keys(obj1), Object.keys(obj2))) {
        return false;
    }
    for (const key in obj1) {
        if (!arraysEqual(obj1[key], obj2[key])) {
            return false;
        }
    }
    return true;
}

export const arraysEqual = (a: string[], b: string[]): boolean => {
    return a.join() === b.join();
};

export const buttonInSegment = (icon: SemanticICONS, onClick: () => any) => (
    <Button style={{ padding: ".2em .5em" }} size={"tiny"} icon={icon} onClick={onClick} />
);
